import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto px-3 py-6 sm:px-4 sm:py-8" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = {
  key: 0,
  class: "mb-6 sm:mb-8"
}
const _hoisted_4 = { class: "flex flex-wrap gap-2 sm:gap-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex items-center justify-between mb-6" }
const _hoisted_8 = { class: "text-xl font-semibold text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "flex items-center space-x-2 bg-gray-100 dark:bg-gray-800 rounded-lg p-1" }
const _hoisted_10 = {
  key: 2,
  class: "text-center py-16"
}

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SearchBar from '../components/SearchBar.vue';
import WallpaperGrid from '../components/WallpaperGrid.vue';
import { wallpaperService, type Wallpaper } from '../firebase/services/wallpaperService';


export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const router = useRouter();

// State
const viewMode = ref('grid'); // 'grid' or 'preview'
const searchQuery = ref('');
const searchResults = ref<Wallpaper[]>([]);
const loading = ref(false);
const hasSearched = ref(false);

// Popular search terms
const popularSearches = ref([
  'nature', 'abstract', 'space', 'city', 'mountain', 'ocean', 'sunset', 'minimalist'
]);

// Methods
const handleSearch = async (query: string) => {
  searchQuery.value = query;
  
  if (!query.trim()) {
    searchResults.value = [];
    hasSearched.value = false;
    return;
  }

  loading.value = true;
  hasSearched.value = true;
  
  try {
    const results = await wallpaperService.searchWallpapers(query.trim());
    searchResults.value = results;
  } catch (error) {
    console.error('Error searching wallpapers:', error);
    searchResults.value = [];
  } finally {
    loading.value = false;
  }
};

const handleClearSearch = () => {
  searchQuery.value = '';
  searchResults.value = [];
  hasSearched.value = false;
};

const handleSuggestionSelect = (suggestion: string) => {
  searchQuery.value = suggestion;
  handleSearch(suggestion);
};

const viewWallpaper = (wallpaper: Wallpaper) => {
  router.push(`/wallpaper/${wallpaper.id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-6 sm:mb-8" }, " Search Wallpapers ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchBar, {
        loading: loading.value,
        suggestions: popularSearches.value,
        placeholder: "Search for wallpapers...",
        onSearch: handleSearch,
        onClear: handleClearSearch,
        onSuggestionSelect: handleSuggestionSelect
      }, null, 8, ["loading", "suggestions"])
    ]),
    (!searchQuery.value && !hasSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-3 sm:mb-4" }, "Popular Searches", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popularSearches.value, (term) => {
              return (_openBlock(), _createElementBlock("button", {
                key: term,
                onClick: ($event: any) => (handleSearch(term)),
                class: "px-3 sm:px-4 py-2 sm:py-2 text-sm sm:text-base bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 active:scale-95 transition-all duration-150"
              }, _toDisplayString(term), 9, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (hasSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(searchResults.value.length > 0 ? `Found ${searchResults.value.length} results for "${searchQuery.value}"` : `No results found for "${searchQuery.value}"`), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (viewMode.value = 'grid')),
                class: _normalizeClass([
            'px-3 py-1 text-sm rounded-md transition-colors',
            viewMode.value === 'grid'
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          ])
              }, " Grid ", 2),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'preview')),
                class: _normalizeClass([
            'px-3 py-1 text-sm rounded-md transition-colors',
            viewMode.value === 'preview'
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          ])
              }, " Device Preview ", 2)
            ])
          ]),
          _createVNode(WallpaperGrid, {
            wallpapers: searchResults.value,
            loading: loading.value,
            "has-more": false,
            "view-mode": viewMode.value,
            onWallpaperClick: viewWallpaper
          }, null, 8, ["wallpapers", "loading", "view-mode"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            class: "w-16 h-16 mx-auto mb-4 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ], -1),
          _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "Start searching", -1),
          _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "Enter keywords to find amazing wallpapers", -1)
        ])))
  ]))
}
}

})